import template from './paginationView.html';
import { PaginationController } from './paginationController';
export const PaginationComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller: PaginationController,
    controllerAs: '$ctrl',
    template,
    bindings: {
        itemsPerPage: '<',
        listItemsPerPage: '<',
        page: '<',
        totalNumberItems: '<',
        totalNumberPages: '<',
        onChange: '&',
        onChangeItemPerPage: '&',
    },
};
